import {AllActivityTypesArray} from "../../types-enums/activity";
import {i18n} from "i18next";
import {DurationProps} from "../../types-enums/activity-common-properties";
import {getDurationInDaysOrNights} from "../getter/common";

/**
 * Generates a tooltip message indicating the count of travel components in the provided activities array.
 *
 * @param {AllActivityTypesArray} activities - Array of all activity types which represent travel components.
 * @param {i18n} i18n - Internationalization instance used for translations.
 * @returns {string} Translated tooltip message indicating the count of travel components.
 */
export const generateTravelComponentCountToolTip = (activities: AllActivityTypesArray, i18n: i18n): string => {
    const countActivities = activities.length
    if (countActivities === 0) return i18n.t("TOOLTIP.COMMON.NO_TRAVEL_COMPONENTS")
    if (countActivities === 1) return i18n.t("TOOLTIP.COMMON.COUNT_TRAVEL_COMPONENTS_SINGULAR", {count: countActivities})
    return i18n.t("TOOLTIP.COMMON.COUNT_TRAVEL_COMPONENTS_PLURAL", {count: countActivities})
}

/**
 * Generates a tooltip message based on the journey duration and activities provided.
 *
 * @param {DurationProps} journeyDuration - The duration of the journey as a duration object.
 * @param {AllActivityTypesArray} activities - An array of all activity types associated with the journey.
 * @param {i18n} i18n - The internationalization object to fetch localized strings.
 *
 * @returns {string} - A localized tooltip message. If no activities are provided, it returns a "no data" message.
 *                     Otherwise, it returns a message indicating the journey duration in singular or plural form.
 */
export const generateJourneyDayCountToolTip = (journeyDuration: DurationProps, activities: AllActivityTypesArray, i18n: i18n): string => {
    const {t} = i18n
    if (activities.length === 0) return t("TOOLTIP.COMMON.NO_DATA_JOURNEY")
    const journeyDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
    if (journeyDurationInDays === 1) return t("TOOLTIP.COMMON.COUNT_DAYS_SINGULAR", {count: journeyDurationInDays!!})
    return t("TOOLTIP.COMMON.COUNT_DAYS_PLURAL", {count: journeyDurationInDays!!})
}